import styled from 'styled-components';

export const Footer = styled.footer`
	border-top: 1px solid #eee;
	margin-top: 56px;
	background-color: #ffffff;
`;

export const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	padding: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: center;
	color: #64748b;
	font-size: 14px;
	font-weight: 500;
`;

export const Copyright = styled.span``;

export const DemoText = styled.span``;
